const reRenderWishlistComponentGlobalEvent = 'wishlist.reRenderTemplate';

/**
 * @typedef {ReturnType<typeof import('widgets/product/QuickAddToCart').default>} QuickAddToCart
 * @typedef {ReturnType<typeof import('widgets/global/ProcessButton').default>} ProcessButton
 */

/**
 * @param {Widget} Widget Base widget for extending
 * @returns {typeof WishListItem} Wishlist item class
 */

export default function (Widget) {
    /**
     * @category widgets
     * @subcategory wishlist
     * @class WishListItem
     * @augments Widget
     * @classdesc Wish list item component with next features:
     * 1. Handles click on product and click on edit button
     * 2. Handles add to cart error
     * 3. Stores actual analytics data
     * @property {string} [addToCartMsg=addToCartMsg] - Reference id for `add to cart message` element
     */
    class HarmonyWishListItem extends Widget {
        /**
         * @description Add global event handlers
         * @returns {void}
         */
        init() {
            super.init();
            this.eventBus().on('availability.update', 'availabilityUpdate');
        }

        /**
         * @description update components after availability check on change qty
         * @param {object} params - params
         */
        availabilityUpdate(params) {
            this.renderAvailability(params);
            this.renderAddToCart(params);
        }

        /**
         * @description Render product availability
         * @param {object} params Product object
         * @returns {void}
         */
        renderAvailability(params) {
            if (!params.pid || this.config.pid !== params.pid) {
                return;
            }

            let message = '';
            let availabilityClass = '';
            let alert = '';

            if (params.availability && (params.availability.isPreorder || params.availability.isBackorder)) {
                if (params.availability.messages) {
                    message = params.availability.messages.join('');
                    availabilityClass = params.availability.class;
                }

                if (params.availability.alerts) {
                    alert = params.availability.alertsCommon.join('');
                }
            }

            this.getById('availability', (availabilityLabel) => {
                /** due to we use global Mustache template for whole wishlist templates are placed on wishlistMgr level,
                 *  so need to trigger render there */
                this.eventBus().emit(reRenderWishlistComponentGlobalEvent, {
                    templateRefId: 'availabilityTemplate',
                    data: {
                        message: message,
                        class: availabilityClass
                    },
                    element: availabilityLabel.ref('container')
                });
            });

            this.getById('availabilityAlert', (availabilityAlert) => {
                /** due to we use global Mustache template for whole wishlist templates are placed on wishlistMgr level,
                 *  so need to trigger render there */
                this.eventBus().emit(reRenderWishlistComponentGlobalEvent, {
                    templateRefId: 'availabilityAlertTemplate',
                    data: {
                        alert: alert
                    },
                    element: availabilityAlert.ref('container')
                });
            });
        }

        /**
         * @description Render Add to Cart btn
         * @param {object} params - params
         */
        renderAddToCart(params) {
            if (!params.pid || this.config.pid !== params.pid) {
                return;
            }

            const QuickAddToCart = /** @type {QuickAddToCart} */(this.getConstructor('quickAddToCart'));
            const ProcessButton = /** @type {ProcessButton} */(this.getConstructor('processButton'));

            this.eachChild(child => {
                if (child instanceof QuickAddToCart) {
                    child.eachChild(button => {
                        if (button instanceof ProcessButton) {
                            /** due to we use global Mustache template for whole wishlist templates are placed on wishlistMgr level,
                             *  so need to trigger render there */
                            this.eventBus().emit(reRenderWishlistComponentGlobalEvent, {
                                templateRefId: 'addToCartTemplate',
                                data: {
                                    available: params.available,
                                    availability: params.availability
                                },
                                element: button.ref('container')
                            });
                        }
                    });
                }
            });
        }
    }
    return HarmonyWishListItem;
}
